import React from 'react';
import { useSelector } from 'react-redux';
export const DebugPoints = () => {
    const debugPoints = useSelector(state => state.editor.debugPoints);
    if (!debugPoints || !debugPoints.length) {
        return null;
    }
    return (React.createElement("g", null, debugPoints.map((pt, idx) => (React.createElement("circle", { 
        // eslint-disable-next-line react/no-array-index-key
        key: `pt_${idx}`, cx: pt.x, cy: pt.y, r: 8, fillOpacity: 0.4, fill: "white", strokeWidth: 4, stroke: "green" })))));
};
